import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const TechnicalDocumentation = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Technical Documents</title>
    <path d="M27.61,4.11h-19v40h31v-28Zm0,5.75,6.25,6.25H27.61Zm8,28.25v2h-23V30.23h2.58l3.7,3.7a3,3,0,0,0-.33,1.34,3,3,0,1,0,3-3,3,3,0,0,0-1.23.27L18,30.23h8.19a3,3,0,1,0,0-2H12.61v-4h4.14a3,3,0,1,0,0-2H12.61V8.11h11v12h12v18Zm-14-3.85a1,1,0,1,1-1,1A1,1,0,0,1,21.56,34.26Zm6.47-5a1,1,0,1,1,1,1A1,1,0,0,1,28,29.23Zm-9.47-6a1,1,0,1,1,1,1A1,1,0,0,1,18.56,23.23Z" />
  </IconBase>
);
